import { Suspense, lazy, useEffect, useState } from "react";
import { Accordion, Badge, Button, Card, Col, Dropdown, Modal, Table } from "react-bootstrap"
import { GetExamQuestions } from '../../../../services/CommonService';
import Pagination from "react-js-pagination";
import EventBus from "../../../../services/EventBus";
import { MathJaxContext } from "better-react-mathjax";

function ViewExamQuestions({ viewprop }) {

    const [questions, setQuestions] = useState([])
    const [percent, setPercent] = useState(50);
   


    useEffect(() => {
        getExamQuestions();
        EventBus.on("loadpagedata", (data) => {
            let obj = {
                payload: {
                    "pageNo": data?.message?.page,
                    "size": 10
                }
            }
            loadData(data?.message?.page);
            //dispatch(fetchAllPaitentsForMedicalBoard({obj:obj}));
        });
        EventBus.remove("loadpagedata");

    }, [])

    const [activePage, setActivePage] = useState(1);
    const [totalRecords, setTotalRecords] = useState(0)

    const handlePageChange = async (pn) => {
        if (pn !== activePage && !isNaN(pn)) {
            loadNextsetofRecords(pn);
        }
    };
    const loadNextsetofRecords = async (pn) => {
        setActivePage(pn);
        EventBus.dispatch("loadpagedata", {
            message: {
                "page": pn
            }

        });
    };

    const loadData = async (pn) => {

        const reqparams = {
            pageno: pn,
            query: { examid: viewprop.id }
        }
        const ResponseData = await GetExamQuestions(reqparams);
        setQuestions(ResponseData.data.docs)
        setTotalRecords(ResponseData.data.totalDocs);
    }

    const getExamQuestions = async () => {
        const reqparams = {
            pageno: 1,
            query: { examid: viewprop.id }
        }
        const ResponseData = await GetExamQuestions(reqparams)
        // console.log("exam questions", ResponseData.data);
        setQuestions(ResponseData.data.docs)
        setTotalRecords(ResponseData.data.totalDocs);

    }

    const fields = {
        subjectname: '',

    }
    const [formfields, setFromFields] = useState(fields);

    const { subjectname } = formfields;


    const handleChange1 = (e) => {
        const { name, value } = e.target;

        setFromFields((prevState) => ({
            ...prevState,
            [name]: value
        }));


    }
    const submitForm = async () => {
        const reqparams = {
            pageno: 1,
            query: {  }
        }
        if(formfields.subjectname !=''){
            reqparams.query.subjectid = formfields.subjectname;
        }
        const ResponseData = await GetExamQuestions(reqparams)
        // console.log("exam questions", ResponseData.data);
        setQuestions(ResponseData.data.docs)
        setTotalRecords(ResponseData.data.totalDocs);



    }
    const resetform = async () => {
        setFromFields(fields)
        getExamQuestions()

    }
    return (
        <>
            <Col>
                <Accordion className="accordion accordion-danger-solid" defaultActiveKey="0">
                    <Accordion.Item key={percent} eventKey={`${percent}`}>
                        <Accordion.Header className="accordion-header">
                            Search
                        </Accordion.Header>
                        <Accordion.Collapse eventKey={`${percent}`} className="accordion__body">
                            <div className="accordion-body">
                                <div className="row">
                                    <div className="form-group mb-3 col-md-6">
                                        <label

                                            htmlFor="val-username"
                                        >
                                            Subject Name
                                        </label>

                                        <select className="form-control" name="subjectname"
                                            value={subjectname} onChange={handleChange1}>
                                            <option value=''>Select</option>
                                            {viewprop?.topics.map(item => (
                                                <option
                                                    key={item.subjectid}
                                                    value={item.subjectid}
                                                >
                                                    {item.name}
                                                </option>
                                            ))}
                                        </select>



                                    </div>




                                    <br />
                                    <div className="form-group">
                                        <button onClick={submitForm} className="btn btn-primary" type="button"
                                        >Search</button>
                                        <button onClick={resetform} className="btn btn-warning" type="button"
                                        >Reset</button>
                                    </div>
                                </div>
                            </div>
                        </Accordion.Collapse>
                    </Accordion.Item>

                </Accordion>
                <Card>
                    <Card.Header>

                    </Card.Header>
                    <Card.Body>
                        <Table responsive>
                            <thead>
                                <tr>
                                    <th className="width80">
                                        <strong>Question No</strong>
                                    </th>
                                    <th>
                                        <strong>Question</strong>
                                    </th>

                                    <th>
                                        <strong>Question Type</strong>
                                    </th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {questions?.map(item => (
                                    <tr key={item.id}>
                                        <td>
                                            <strong>{item.questionno}</strong>
                                        </td>
                                        <td>
                                            {/* <div dangerouslySetInnerHTML={{ __html: item.title }} />*/}


                                            <MathJaxContext>
                                                <div dangerouslySetInnerHTML={{ __html: item.title }} />
                                            </MathJaxContext>

                                        </td>
                                        <td>{item.type}</td>


                                    </tr>
                                ))}

                            </tbody>
                        </Table>
                        <div >

                            <Pagination
                                activePage={activePage}
                                itemsCountPerPage={10}
                                totalItemsCount={totalRecords}
                                pageRangeDisplayed={5}
                                onChange={handlePageChange}
                                activeClass="active"
                                itemClass="page-item"
                                innerClass="pagination mb-0"
                                linkClass="page-link"
                                firstPageText="First"
                                lastPageText="Last"
                                prevPageText="Previous"
                                nextPageText="Next"
                                disabledClass="disabled"
                                activeLinkClass="disabled"
                            />
                        </div>
                    </Card.Body>
                </Card>
            </Col>
        </>
    )
}

export default ViewExamQuestions